import React from 'react';

import Popper from 'ha/ui/next/Popper';
import Track from 'ha/components/track/SmartTrack';

import SearchMapPreview from '../SearchMapPreview';
import Pin from './Pin';
import { MapProps, RoomMarker as RoomMarkerType } from './Types';

const padding = {
  top: 70,
  bottom: 70,
  left: 16,
  right: 16,
};

interface Props {
  marker: RoomMarkerType;
  highlightedRoomId: number;
  highlightedInList: boolean;
  lat: number;
  lng: number;
  boundariesElement?: HTMLDivElement | null;
}

const RoomMarkerDesktop: React.FC<Props & Partial<MapProps>> = ({
  marker,
  highlightedRoomId,
  highlightedInList,
  $hover: hovered,
  boundariesElement,
}) => {
  const modifiers = {
    preventOverflow: {
      enabled: true,
      boundariesElement,
      padding,
    },
  };

  const anchor = (
    <Track name="Clicked on a pin with price in map" type="button">
      <Pin
        marker={marker}
        emphasis={hovered || highlightedInList}
        highlightedRoomId={highlightedRoomId}
      />
    </Track>
  );

  return (
    <Popper anchor={anchor} modifiers={modifiers}>
      {({ handleClose }) => (
        <SearchMapPreview rooms={marker.rooms} onClose={handleClose} />
      )}
    </Popper>
  );
};

export default RoomMarkerDesktop;
